import { useEffect, useState } from 'react';
import { FastSpringPaymentContext } from './context/FastSpringPaymentContext';
import Plans from './components/plans/Plans';

const OneOffFastSpringPaymentV2 = ({ isTest }) => {
	const [email, setEmail] = useState();
	const [promo, setPromo] = useState();
	const [ltl, setLtl] = useState();

	useEffect(() => {
		setTimeout(() => {
			setEmail(() => localStorage.getItem('quiz_email'));
			const promo = localStorage.getItem('promo');
			const ltl = localStorage.getItem('ltl');

			if (promo) {
				setPromo(() => true);
			}

			if (ltl) {
				setLtl(() => ltl);
			}
		}, 100);
	}, []);

	return (
		<>
			<FastSpringPaymentContext.Provider
				value={{
					email,
					promo,
					ltl,
					isTest,
				}}
			>
				<Plans />
			</FastSpringPaymentContext.Provider>
		</>
	);
};

export default OneOffFastSpringPaymentV2;
